import { Create, SimpleForm, type CreateProps } from "react-admin";
import { EventFormFields } from "./EventFormFields";
import { normalizeEventPayload } from "./event-payload";

export const EventCreate = (props: CreateProps) => (
  <Create {...props} redirect="/events" transform={normalizeEventPayload}>
    <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 700 }}>
      <EventFormFields />
    </SimpleForm>
  </Create>
);
